module.exports = __webpack_public_path__ + "img/forbidden.aa717b1d.gif";